<template>
    <SiteLayout class="container mx-auto max-w-[1566px]">
        <div class="grid border-transparent border-none">
            
            <TopHeader />
            <HeroSection  :heroBanners="hero_banners"/>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-1 gap-0 p-0 mx-auto">
                <CategoryCarousel :categoryName="category?.category_name" v-for="(category, index) in categories" :key="index" :category="category" />
            </div>
            
        </div>
       
    </SiteLayout>
    <div class="mx-auto">
        <FooterSection />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { ProductService } from '@/Services/ProductService';  
import { ProductGrid } from '@/Services/ProductGrid';  
import VideoBanner from './VideoBanner.vue';
import TopHeader from '@/Pages/TopHeader.vue';
import HeroSection from '@/Pages/HeroSection.vue';
import CategoryCarousel from '@/Pages/CategoryCarousel.vue';
import CategoryProduct from '@/Pages/CategoryProduct.vue';
import FooterSection from '@/Pages/FooterSection.vue';
import CategoryModel from '@/Interfaces/Category/CategoryModel';
import SiteLayout from '@/Layouts/SiteLayout.vue';
import BannerManagementModel from '@/Interfaces/BannerManagement/BannerManagementModel';

defineProps<{
    'hero_banners': BannerManagementModel
    'categories': CategoryModel
}>()

onMounted(() => {
    ProductGrid.getProducts().then((data) => (productsGrid.value = data.slice(0, 20)));
})

const title = ref('');
const productsGrid = ref<Object>({});
const layout = ref<string>('grid');
const options = ref<string[]>(['list', 'grid']);


const getSeverity = (status: string) => {
    switch (status) {
        case 'INSTOCK':
            return 'success';

        case 'LOWSTOCK':
            return 'warn';

        case 'OUTOFSTOCK':
            return 'danger';

        default:
            return null;
    }
};

const getGridSeverity = (product: Object) => {
    switch (product?.inventoryStatus) {
        case 'INSTOCK':
            return 'success';

        case 'LOWSTOCK':
            return 'warn';

        case 'OUTOFSTOCK':
            return 'danger';

        default:
            return null;
    }
}

const productForCart = ref();
const addToCart = (item) => {
    productForCart.value = item;
}
</script>